/* eslint-disable react/no-array-index-key, no-underscore-dangle, camelcase, no-plusplus */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Lockr from 'lockr';
import _ from 'lodash';
import {
  scorm, report, booksTrack, statistic,
} from '@/api';
import {
  LIBRARY_XML_ORIGIN_URL,
  DEVICE, STORAGE_KEY,
  IDENTITY_KEY_NAME,
} from '@/constants';
import RiseLoading from '@/routes/components/Loading';
import {
  nativeFunction,
  callNativeFunction,
  nativeFunctionParamsConstant,
  OS, getIdentity,
} from '@/utils/detectDevice';
import { quitBook, convertObject } from '@/utils/tools';
import Loading from '@/components/Loading';
import Score from '@/components/Score';
import RiseError from '@/components/RiseError';
import RequestErrors from '@/components/RequestErrors';
import RecordingReadingBtn from '@/components/Lottie/RecordingReadingBtn';
import Page from './components/Page';
import './style';
// 120403, 23401
const errorUser = [];
const errorMsgs = [];
const alertByUser = async (msg) => {
  const studentId = await getIdentity(IDENTITY_KEY_NAME.UID);
  errorUser.includes(parseInt(studentId, 10)) && errorMsgs.push(msg);
};

const ERROR_TEXT = '数据异常';
const ERROR = {
  DATA: {
    P: `key[p] - ${ERROR_TEXT}`,
    S: `key[s] - ${ERROR_TEXT}`,
    W: `key[w] - ${ERROR_TEXT}`,
  },
};

// const Junior = React.lazy(() => import('./Junior'));
// const Senior = React.lazy(() => import('./Senior'));
const Speed = [
  { num: 0.75, txt: 'Slow' },
  { num: 1, txt: 'Normal' },
  { num: 1.5, txt: 'Fast' },
];

const recoderErrorCode = [
  1015,
  1016,
  1017,
];
const recoderError = {
  [recoderErrorCode[0]]: '录音受损，请重新录音或检查麦克风设置',
  [recoderErrorCode[1]]: '我听不懂你在说什么，可以说清楚点吗？',
  [recoderErrorCode[2]]: '周围噪音过大，请重新录音',
};

@withRouter
class Reading extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      audioCurrentTime: 0,
      recorder: {},
      evaluating: false,
      recording: false,
      playing: false,
      isPlay: false,
      recordDis: false,
      playDis: true,
      barDis: true,
      reading: false,
      readDis: false,
      speed: Speed[1],
      bookIndex: 0,
      result: [],
      essayOriginWordList: [],
      essayOriginDataList: [],
      bookData: null,
      params: null,
      url: `${OS.URL_HOST()}Library/`,
      phoneAudioRecorderSrc: undefined,
      loading: { show: false, txt: '' },
      score: { show: false, num: 0, isSenior: false },
      recordError: { show: false, txt: '' },
      isReport: false,
      requestCode: 0,
      isSenior: true,
      new_attempt: 0,
    };
    this.audio = React.createRef();
  }

  componentWillMount() {
    (OS.TYPE !== DEVICE.PC && Lockr.get(STORAGE_KEY.PAGES, null) === null)
      && this.props.history.push('/');
    this.setState({ params: this.props.match ? this.props.match.params : null }, () => {
      this.getScorm();
    });
  }

  componentDidMount() {
    this.getRecorder();
    window.onfire.on('setTimeUpdate', ({ time }) => {
      this.onTimeUpdate(time);
    });
    window.onfire.on('endedPlay', this.endPlay);
    window.onfire.on('endPlayMyRecordingUI', this.endPlayMyRecordingUI);
  }

  componentWillUnmount() {
    this.state.recorder.destructor();
    window.onfire.off('setTimeUpdate');
    window.onfire.off('endedPlay');
    window.onfire.off('endPlayMyRecordingUI');
  }

  getRecorder = async () => {
    const { default: Recorder } = OS.TYPE === DEVICE.PC
      ? await import('@/utils/recorderPc')
      : await import('@/utils/recorderPhone');
    const recorder = new Recorder(
      this.recorderResult,
      this.recorderStop,
      this.recorderStopPlayLocal,
      this.recorderError,
      this.startRecordUI,
    );
    this.setState({ recorder });
  }

  getScorm = async () => {
    const { params } = this.state;
    const stageId = params.stageId.split('-')[0];
    const reqParams = {
      ...params,
      stageId,
    };
    alertByUser(`getScorm set params: ${stageId}`);
    const result = await scorm.list(reqParams);
    alertByUser('getScorm got result');
    const { code, data } = convertObject(result);
    code === 200 && this.init(data[0]);
    alertByUser(`getScorm code: ${code}`);
    this.setState({ requestCode: code });
    this.setState({ new_attempt: data[0].new_attempt });
  };

  init = async ({ page, level }) => {
    alertByUser('init start');
    const { params } = this.state;
    const studentId = await getIdentity(IDENTITY_KEY_NAME.UID);
    alertByUser(`init studentId: ${studentId}`);
    const index = Lockr.get(`${studentId}${params.id}`)
      && Lockr.get(`${studentId}${params.id}`).type === 'reading'
      ? Lockr.get(`${studentId}${params.id}`).val
      : 0;
    Lockr.set(`${studentId}${params.id}`, { type: 'reading', val: index });
    const bookData = page.filter(item => item.vms_sco_type === 'SRS');
    this.setState({
      bookData,
      bookIndex: index + 1,
      isSenior: level !== 'low',
    }, () => {
      alertByUser(`init set bookData ${'callback'}`);
      const { title_id: fileName } = bookData[index];
      fileName && this.XMLToEssay(
        OS.TYPE === DEVICE.PC
          ? scorm.xml(`${LIBRARY_XML_ORIGIN_URL}Library/${fileName}/${fileName}.xml`).data
          : scorm.localXml(fileName),
      );
      alertByUser(`init ${'localXml'} finished`);
    });
  };

  recorderError = (err) => {
    (err && recoderError[err.code]) && this.RecordErrorShow(recoderError[err.code]);
  }

  recorderStopPlayLocal = () => this.setState({ playing: false, recordDis: false, readDis: false });

  recorderStop = () => this.setState({ evaluating: true });

  recorderResult = ({ result, src }) => {
    const { recorder: { recorder } } = this.state;
    const url = src || recorder.getSoundUrl();
    if (result) {
      this.loadingShow('Scoring');
      this.scoreShow(result.lines[0].score, url);
      const validWord = result.lines[0].words.filter(word => [1, 2, 4, 8].includes(word.type));
      // console.log('validWord', validWord);
      this.markWords(validWord);
      statistic.post({ speak_num: 1 });
      console.log('reading page: recorderResult statistic.post - speak_num');
    }
    this.setRecordResutUI({ url });
    this.setState({ evaluating: false, phoneAudioRecorderSrc: src, recording: false });
  };

  flatArray = (origin) => {
    // 移动端不认flat()
    if (!Array.isArray(origin[0])) return origin;
    const flat = [];
    origin.forEach((element) => {
      flat.push(...element);
    });
    return this.flatArray(flat);
  };

  XMLToEssay = (xml) => {
    const defaultValue = error => [{
      s: [{
        w: [{
          _attr: {
            id: { _value: 0 },
            start_audio: { _value: 0 },
            end_audio: { _value: 0 },
            variants: { _value: '' },
          },
          _text: error,
        }],
        _attr: {
          start_audio: { _value: 0 },
          end_audio: { _value: 0 },
        },
      }],
    }];
    console.log('xml.text', xml);
    const p = _.get(xml, 'text[0].p', defaultValue(ERROR.DATA.P));
    console.log('p', p);
    const sectionArr = p.map(item => _.get(item, 's', defaultValue(ERROR.DATA.S)[0].s));
    // sectionArr = [[]];
    console.log('sectionArr', sectionArr);
    // console.log(sectionArr.map(item => item.map(sub => sub)));
    const essayOriginDataList = sectionArr.map(item => item.map(sub => sub));
    // console.log('essayOriginDataList', essayOriginDataList);
    const essayOriginWordList = sectionArr.map(item => item.map(sub => _.get(sub, 'w', defaultValue(ERROR.DATA.W)[0].s[0].w)))
      .map(item => item.map(sub => sub.map(({ _text: text }) => text)));
    console.log('essayOriginWordList', this.flatArray(essayOriginWordList));
    this.setState({
      essayOriginDataList,
      essayOriginWordList,
    }, () => {
      const wordList = this.flatArray(essayOriginWordList);
      if (wordList.some(item => item.toString().indexOf(ERROR_TEXT) > -1)) {
        console.log(nativeFunction.REMOVE_CURRENT_BOOK_RESOURCE);
        callNativeFunction(nativeFunction.REMOVE_CURRENT_BOOK_RESOURCE)();
      }
      statistic.post({ read_words_num: wordList.length });
    });
  };

  startRecord = async (e) => {
    e.preventDefault();
    const {
      recorder: { start, stop },
      recording, recordDis,
      essayOriginWordList,
    } = this.state;
    if (!recordDis && start && stop && essayOriginWordList.length) {
      if (recording) {
        this.setState(({ loading }) => ({
          loading: {
            ...loading,
            show: true,
            txt: 'Processing',
          },
          recording: false,
          playDis: false,
          readDis: false,
        }), () => {
          stop();
        });
      } else {
        this.resetEssayCotent();
        start(essayOriginWordList.join(' '));
      }
    }
  };

  startRecordUI = () => {
    this.setState({
      recording: true,
      recordDis: false,
      playDis: true,
      readDis: true,
    });
  };

  setRecordResutUI = ({ url }) => {
    this.setState({
      isPlay: !!url,
      playDis: !url,
    }, () => {
      const { loading: { show, txt } } = this.state;
      (show && txt === 'Processing') && this.loadingHide();
    });
  };

  play = (e) => {
    e.preventDefault();
    const { playing } = this.state;
    !playing ? this.startPlayMyRecording() : this.stopPlayMyRecording();
  };

  startPlayMyRecording = () => {
    const { recorder, phoneAudioRecorderSrc } = this.state;
    this.setState({ playing: true, recordDis: true, readDis: true }, () => {
      recorder.play(phoneAudioRecorderSrc);
    });
  };

  stopPlayMyRecording = () => {
    this.setState({ playing: false, readDis: false, recordDis: false }, () => {
      const { recorder: { stopPlay } } = this.state;
      stopPlay && stopPlay();
    });
  };

  toggleVisibility = (component) => {
    this.setState(state => ({
      [component]: !state[component],
    }));
  };

  markWords = result => this.setState({ result });

  resetEssayCotent = () => (
    this.setState(() => ({
      result: [],
      evaluating: false,
    }))
  );

  getWordType = ({ type, score }) => {
    if (type === 1) return 'misread';
    const pass = score >= 6.0 ? 'vague' : 'incorrect';
    const color = score >= 7.5 ? 'correct' : pass;
    return color;
  };

  generateResult = (result) => {
    // console.log('generateResult', result);
    let current = 0;
    const header = this.getHeader(this.state.essayOriginDataList);
    const content = this.getContent(this.state.essayOriginDataList);
    return (
      <React.Fragment>
        <div style={{ marginBottom: header ? '10px' : '0px' }}>
          {header ? header.map((p, pIdx) => (
            <React.Fragment key={`frag-header-${pIdx}`}>
              {p.br && <br key={`br-header-${pIdx}`} />}
              {p.w.map((span, spanIdx) => this.generateSpan({
                classname: this.getWordType(result[current++]),
                style: span._attr.style,
                text: span._text,
                key: `span-header-result-${pIdx}-${spanIdx}`,
              }))}
            </React.Fragment>
          )) : null}
        </div>
        {content.map((p, pIdx) => (
          <React.Fragment key={`frag-content-${pIdx}`}>
            {p.br && <br key={`br-content-${pIdx}`} />}
            {p.w.map((span, spanIdx) => this.generateSpan({
              classname: this.getWordType(result[current++]),
              style: span._attr.style,
              text: span._text,
              key: `span-content-result-${pIdx}-${spanIdx}`,
            }))}
          </React.Fragment>
        ))}
      </React.Fragment>
    );
  };

  generateSpan = ({
    classname, text, key, style,
  }) => (
    <span
      className={`${style && style._value} word-${classname}`}
      key={key}
    >
      {`${text} `}
    </span>
  );

  generateReadSpan = ({
    time, style, text, key,
  }) => this.generateSpan({
    classname: this.state.audioCurrentTime > time ? 'correct' : 'unread',
    text,
    key,
    style,
  });

  // eslint-disable-next-line
  getHeader = data => data.filter(item => item.filter(p => p.w.filter(i => i._attr.style).length > 0).length > 0)[0];

  // eslint-disable-next-line
  getContent = data => data.filter(item => item.filter(p => p.w.filter(i => !i._attr.style).length > 0).length > 0)[0];

  generatePhase = (arr, keyName) => arr.map((p, pIdx) => (
    <React.Fragment key={`frag-${pIdx}`}>
      {p.br && <br key={`br-${pIdx}`} />}
      {p.w.map((span, spanIdx) => this.generateReadSpan({
        style: span._attr.style,
        time: span._attr.start_audio._value,
        text: span._text,
        key: `span-${keyName}-unread-${pIdx}-${spanIdx}`,
      }))}
    </React.Fragment>
  ));

  renderReadingEffect = () => {
    const header = this.getHeader(this.state.essayOriginDataList);
    const content = this.getContent(this.state.essayOriginDataList);
    return (
      <React.Fragment>
        <div style={{ marginBottom: header ? '10px' : '0px' }}>
          {header ? this.generatePhase(header, 'title') : null}
        </div>
        {content ? this.generatePhase(content, 'content') : null}
      </React.Fragment>
    );
  };

  onTimeUpdate = (audioCurrentTime = this.audio.current.currentTime) => {
    this.setState(({ reading }) => ({
      audioCurrentTime: reading
        ? Math.round(audioCurrentTime * 100)
        : 0,
    }));
  };

  onPlay = () => {
    const {
      isPlay, reading, two, playing,
    } = this.state;
    // console.log('onPlay.playing', playing);
    if (playing) return;
    if (OS.TYPE !== 'pc') {
      this.mobileOnPlay();
      return;
    }
    // this.audio.current.addEventListener('ended', () => {
    //   console.log('audio ended');
    //   this.endPlay();
    // });
    !reading ? this.setState({
      playDis: true,
      recordDis: true,
      barDis: !two,
      reading: true,
    }, () => {
      this.audio.current.playbackRate = this.state.speed.num;
      this.audio.current.play();
      this.resetEssayCotent();
    }) : this.setState({
      recordDis: false,
      playDis: !isPlay,
      barDis: true,
      reading: false,
    }, () => {
      this.audio.current.pause();
      this.audio.current.currentTime = 0;
      console.log('onPlay');
      statistic.post({ listen_num: 1 });
      console.log('reading onPlay listen_num: 1');
    });
  };

  mobileOnPlay = () => {
    const {
      isPlay,
      reading,
      bookData,
      bookIndex,
      url,
      speed: { num },
    } = this.state;
    const audioUrl = bookData && `${url}${bookData[bookIndex - 1].title_id}/${bookData[bookIndex - 1].title_id}_Audio.ogg`;
    callNativeFunction(nativeFunction.PLAY_LOCAL_AUDIO)({
      url: audioUrl,
      speed: num,
      type: nativeFunctionParamsConstant.AUDIO,
    });
    !reading ? this.setState({
      playDis: true,
      recordDis: true,
      barDis: false,
      reading: true,
    }, () => {
      this.resetEssayCotent();
    }) : this.setState({
      recordDis: false,
      playDis: !isPlay,
      barDis: true,
      reading: false,
      audioCurrentTime: 0,
    });
  };

  endPlay = () => {
    const { isPlay } = this.state;
    this.setState({
      recordDis: false,
      playDis: !isPlay,
      barDis: true,
      reading: false,
      readDis: false,
    }, () => {
      console.log('endPlay');
      statistic.post({ listen_num: 1 });
      console.log('reading endPlay listen_num: 1');
    });
  };

  endPlayMyRecordingUI = () => {
    this.setState({
      playing: false,
      recordDis: false,
      readDis: false,
    });
  };

  speed = () => {
    const { speed } = this.state;
    const prevIndex = Speed.findIndex(item => item === speed);
    const currentSpeed = (prevIndex + 1) === Speed.length
      ? Speed[0]
      : Speed[prevIndex + 1];
    this.audio.current.playbackRate = currentSpeed.num;
    this.setState({ speed: currentSpeed });
  };

  changePages = async (selected) => {
    // console.log('changePages', selected, this.state.bookIndex);
    if (this.state.bookIndex !== (selected + 1)) {
      // 翻页导致点击页面会取消播放，需换翻页方法
      this.stopPlayMyRecording();
      const { bookData, params, recorder: { cancelRecording } } = this.state;
      cancelRecording && cancelRecording();
      const { title_id: fileName } = bookData[selected];
      console.log(selected);
      selected !== this.state.bookIndex - 1
      && this.setState({
        evaluating: false,
        recording: false,
        playing: false,
        reading: false,
        isPlay: false,
        recordDis: false,
        playDis: true,
        result: [],
        essayOriginWordList: [],
        essayOriginDataList: [],
        bookIndex: selected + 1,
        audioCurrentTime: 0,
      }, async () => {
        this.XMLToEssay(
          OS.TYPE === DEVICE.PC
            ? scorm.xml(`${LIBRARY_XML_ORIGIN_URL}Library/${fileName}/${fileName}.xml`).data
            : scorm.localXml(fileName),
        );
        Lockr.set(`${await getIdentity(IDENTITY_KEY_NAME.UID)}${params.id}`, { type: 'reading', val: selected });
      });
    }
  }

  barDisabled = () => {
    this.setState({ barDis: true });
  }

  handleExercises = () => {
    const { params, recorder: { cancelRecording }, new_attempt } = this.state;
    this.stopPlayMyRecording();
    cancelRecording && cancelRecording();
    this.props.history.push(`/reading_report/${params.id}/${params.attempt}/${params.stage}/${params.stageId}/${new_attempt}`);
  }

  handleBookCover = () => {
    const { params, recorder: { cancelRecording } } = this.state;
    console.log(this.state);
    this.stopPlayMyRecording();
    cancelRecording && cancelRecording();
    this.props.history.push(`/cover/${params.id}/${params.attempt}/${params.stage}/${params.stageId}`);
  }

  handleClose = async () => {
    callNativeFunction(nativeFunction.STOP_LOCAL_ALL)({
      type: nativeFunctionParamsConstant.FLIP,
    });
    const { params, isReport } = this.state;
    isReport && await report.list(params.id, params.attempt);
    quitBook({ params, push: this.props.history.push }); // 封装的一个跳转方法，含有跳app和内部跳转
  }

  loadingShow = (txt) => {
    this.setState(({ loading }) => ({
      loading: { ...loading, show: true, txt },
    }));
  };

  loadingHide = () => {
    this.setState(({ loading }) => ({
      loading: { ...loading, show: false },
    }));
  }

  scoreShow = async (num, src) => {
    const { bookData, bookIndex, params } = this.state;
    this.setState(({ score, loading }) => ({
      loading: Object.assign({}, loading, {
        show: false,
      }),
      score: Object.assign({}, score, {
        show: true,
        num,
      }),
    }));
    const studentId = await getIdentity(IDENTITY_KEY_NAME.UID);
    const oldScore = Lockr.get(`${studentId}${bookData[bookIndex - 1].scoid}score`) ? Lockr.get(`${studentId}${bookData[bookIndex - 1].scoid}score`) : 0;
    console.log('mujin 分数------ :>> ', num, oldScore, src);
    await booksTrack.post({
      scormid: parseInt(params.id, 10),
      scoid: bookData[bookIndex - 1].scoid,
      element: 'cmi.core.read.raw',
      value: num,
      attempt: parseInt(params.attempt, 10),
    }) && await booksTrack.post({
      scormid: parseInt(params.id, 10),
      scoid: bookData[bookIndex - 1].scoid,
      element: 'cmi.core.record.url',
      value: src,
      attempt: parseInt(params.attempt, 10),
    }) && Lockr.set(`${studentId}${bookData[bookIndex - 1].scoid}score`, num);
    this.setState({ isReport: true });
  };

  scoreHide = () => {
    this.setState(({ score }) => ({
      score: Object.assign({}, score, {
        show: false,
      }),
    }));
  }

  RecordErrorShow = (txt) => {
    this.setState(({ recordError }) => ({
      recordError: Object.assign({}, recordError, {
        show: true,
        txt,
      }),
    }));
  };

  RecordErrorHide = () => {
    this.setState(({ recordError }) => ({
      recordError: Object.assign({}, recordError, {
        show: false,
      }),
    }));
  }

  render() {
    const {
      result,
      evaluating,
      recording,
      barDis,
      playing,
      speed,
      bookIndex,
      playDis,
      recordDis,
      bookData,
      url,
      reading,
      readDis,
      loading,
      score,
      recordError,
      requestCode,
      isSenior,
    } = this.state;
    return (
      <div className="reading-container">
        {requestCode === 0 ? <RiseLoading /> : null}
        {requestCode === 408 ? <RequestErrors callback={this.handleClose} /> : null}
        <div className="reading-wrapper">
          <div className="reading-header">
            <div className="reading-close" onClick={this.handleClose} />
            <div>{errorMsgs.map(error => <div key={error}>{error}</div>)}</div>
            <div className="reading-page-num">
              <span className="current-page">{`${bookIndex}/`}</span>
              <span className="page-count">{bookData && bookData.length}</span>
            </div>
          </div>
          <div className="book-wrapper">
            {bookData
              ? (
                <Page
                  result={result}
                  evaluating={evaluating}
                  generateResult={this.generateResult}
                  renderReadingEffect={this.renderReadingEffect}
                  bookData={bookData}
                  onPlay={this.onPlay}
                  isPlay={reading}
                  readDis={readDis}
                  changePages={this.changePages}
                  bookIndex={bookIndex}
                  isSenior={isSenior}
                  barDis={barDis}
                />
              )
              : null
            }
          </div>
          {bookData && bookIndex === 1 ? <div className="book-prev" onClick={this.handleBookCover} /> : null}
          {bookData && bookIndex === bookData.length ? <div className="book-next" onClick={this.handleExercises} /> : <div className="book-footer" />}
          <div id="btn-group" className={`btn-group ${isSenior && (barDis ? 'block' : 'none')}`}>
            <div className={`speed${recording ? ' dis' : ''}`} onClick={recording ? null : this.speed}>{speed.txt}</div>
            {recording
              ? <div className="read-recording-animation" onClick={this.startRecord}><RecordingReadingBtn /></div>
              : <div className={`read-recording${recordDis ? ' dis' : ''}`} onClick={!recordDis ? this.startRecord : null} />
            }
            <div className={`read-replay${playing ? ' animation' : ''}${playDis ? ' dis' : ''}`} onClick={!playDis ? this.play : null}>
              <div className={`${playing && !playDis ? 'playing' : ''}`} />
            </div>
          </div>
          {isSenior
            ? (
              <div className={`bar-container${barDis ? ' none' : ' block'}`}>
                <div className="btn-bar" onClick={this.barDisabled} />
              </div>
            )
            : null
          }
          <audio
            controls="controls"
            preload="auto"
            ref={this.audio}
            onTimeUpdate={() => this.onTimeUpdate()}
            onEnded={this.endPlay}
            style={{ display: 'none' }}
            src={bookData && `${url}${bookData[bookIndex - 1].title_id}/${bookData[bookIndex - 1].title_id}_Audio.ogg`}
            type="audio/ogg"
          />
        </div>
        {loading.show ? <Loading txt={loading.txt} hide={this.loadingHide} /> : null}
        {!loading.show && score.show && !recordError.show
          ? <Score num={score.num} isSenior={isSenior} hide={this.scoreHide} />
          : null
        }
        {recordError.show
          ? <RiseError txt={recordError.txt} hide={this.RecordErrorHide} />
          : null
        }
      </div>
    );
  }
}

export default Reading;
